export default function($) {
  const contactform = $('form#contact-form');
  const agencyform = $('form#agency-form');

  if( $("#make_appointment").is(":checked") ) {
    $("#appointments-choices").show();
  } else {
    $("#appointments-choices").hide();
  }

  $("#make_appointment").change(function() {
    if( $(this).is(":checked") ) {
      $("#appointments-choices").show();
    } else {
      $("#appointments-choices").hide();
    }
  });

  contactform.on('submit', function(e) {
    if( $(this).data('submitted') === true ) {
      console.log('Form is already submitted, waiting for response');
      e.preventDefault();
    } else {
      const selectedCity = $("#contact-form #selected_city").val();

      if ( !selectedCity ) {
        e.preventDefault();
        $('#error-selected-city').removeClass('hidden');
        return false;
      } else {
        $(this).data('submitted', true);
      }
    }
  });
  agencyform.on('submit', function(e) {
    if( $(this).data('submitted') === true ) {
      console.log('Form is already submitted, waiting for response');
      e.preventDefault();
    } else {
      const selectedCity = $("#contact-form #selected_city").val();

      if ( !selectedCity ) {
        e.preventDefault();
        $('#error-selected-city').removeClass('hidden');
        return false;
      } else {
        $(this).data('submitted', true);
      }

    }
  });
}
